/** Organisation-free: push devices belong to the signed-in member. */
export const pushKeys = {
  all: ['push'] as const,
  settings: () => [...pushKeys.all, 'settings'] as const,
  thisDevice: (publicKey: string) => [...pushKeys.all, 'this-device', publicKey] as const,
};
